// eslint-disable-next-line import/no-cycle
import { getDropdownSubMenuComponents } from "../logic";
var useDropdownSubmenuItems = function useDropdownSubmenuItems(items) {
  return getDropdownSubMenuComponents(items);
};
export default useDropdownSubmenuItems;